"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractVersion = exports.Network = void 0;
var Network;
(function (Network) {
    Network["goerli"] = "goerli";
    Network["mainnet"] = "mainnet";
})(Network = exports.Network || (exports.Network = {}));
class ContractVersion {
    get abi() {
        return this.deployedContractsByVersion[this.version].abi;
    }
    get mainnetAddress() {
        return this.deployedContractsByVersion[this.version].mainnetAddress.toLowerCase();
    }
    get goerliAddress() {
        return this.deployedContractsByVersion[this.version].goerliAddress.toLowerCase();
    }
    get goerliAddresses() {
        return Object.keys(this.deployedContractsByVersion).map((version) => this.deployedContractsByVersion[version].goerliAddress);
    }
    get mainnetAddresses() {
        return Object.keys(this.deployedContractsByVersion).map((version) => this.deployedContractsByVersion[version].mainnetAddress);
    }
    get abiByAddress() {
        return Object.keys(this.deployedContractsByVersion).reduce((acc, version) => {
            const deployedContract = this.deployedContractsByVersion[version];
            acc[deployedContract.mainnetAddress.toLowerCase()] =
                deployedContract.abi;
            acc[deployedContract.goerliAddress.toLowerCase()] =
                deployedContract.abi;
            return acc;
        }, {});
    }
    getAbiByAddress(address) {
        return this.abiByAddress[Object.keys(this.abiByAddress).find((a) => a.toLowerCase() === address.toLowerCase())];
    }
    getVersionByAddress(address) {
        if (!this.isKnownAddress(address)) {
            throw new Error("Unknown address");
        }
        return Object.keys(this.deployedContractsByVersion).find((version) => this.deployedContractsByVersion[version].mainnetAddress.toLowerCase() === address.toLowerCase() ||
            this.deployedContractsByVersion[version].goerliAddress.toLowerCase() ===
                address.toLowerCase());
    }
    isKnownAddress(address) {
        return Boolean(this.getAbiByAddress(address));
    }
}
exports.ContractVersion = ContractVersion;
//# sourceMappingURL=ContractVersion.js.map